export const USER_ENV = {
	PUIG: 'puig',
	DIPI: 'dipi'
}

export const USER_ROLE = {
	STANDARD: 'user',
	ADMIN: 'admin',
	REVERSE: 'reverse',
	VT_TAGGER: 'vt_tagger'
}